import type { QueryClient } from '@tanstack/react-query';
import type { Layout as UIAPILayout, Template as UIAPITemplate } from '@customerio/hydra-ui-api';
import { parseLayout, type Layout } from '../layout/entity';
import { parseTemplate, templateKeys, type Template } from './entity';

/**
 * Propagation for the template response shape: a `template` with the
 * `layouts` it side-loads (`GET /templates/:id` sends the email's layout).
 */

export interface ParsedTemplateWithLayouts {
  template: Template;
  layouts: readonly Layout[];
}

export function parseTemplateWithLayouts(
  template: UIAPITemplate,
  layouts: readonly UIAPILayout[],
): ParsedTemplateWithLayouts {
  return { template: parseTemplate(template), layouts: layouts.map(parseLayout) };
}

export function populateTemplateWithLayouts(
  qc: QueryClient,
  workspaceId: number,
  parsed: ParsedTemplateWithLayouts,
): void {
  qc.setQueryData(templateKeys.detail(workspaceId, parsed.template.id), parsed.template);
  qc.setQueryData(templateKeys.layouts(workspaceId, parsed.template.id), parsed.layouts);
}
